import { render, staticRenderFns } from "./FromBuilder.vue?vue&type=template&id=81d390ee&scoped=true"
import script from "./FromBuilder.vue?vue&type=script&lang=js"
export * from "./FromBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d390ee",
  null
  
)

export default component.exports